import { Box, createTheme, ThemeProvider } from "@mui/material";
import React, { useEffect } from "react";
import TableToolbar from "../../../shared/components/tables/TableToolbar";
import { classNames } from "../../../shared/models/models";
import TableToolbarSearch from "../../../shared/components/tables/TableToolbarSearch";
import TableToolbarSelect from "../../../shared/components/tables/TableToolbarSelect";
import { CategoryReference, InstalledStockItemsQuery, ManufacturerReference } from "../../inventory/models/models";
import useTranslation from "../../../shared/hooks/useTranslation";

type InstalledStockItemsTableToolbarProps = {
  query: InstalledStockItemsQuery;
  categories: CategoryReference[];
  manufacturers: ManufacturerReference[];
  onChange: (query: InstalledStockItemsQuery) => void;
  className?: string;
};

const InstalledStockItemsTableToolbar = ({
  query,
  categories,
  manufacturers,
  onChange,
  className
}: InstalledStockItemsTableToolbarProps) => {
  const handleQueryChange = (query: InstalledStockItemsQuery): void => {
    if (onChange) {
      onChange(query);
    }
  };

  const handleSearch = (value?: string) => {
    handleQueryChange({ ...query, search: value });
  };

  const handleCategoryChange = (categoryId: string) => {
    handleQueryChange({ ...query, categoryId: categoryId ? categoryId : undefined });
  };

  const handleManufacturerChange = (manufacturerId: string) => {
    handleQueryChange({ ...query, manufacturerId: manufacturerId ? manufacturerId : undefined });
  };

  const theme = createTheme({});

  const { translate } = useTranslation("myMachinery");
  const { translate: tCommon } = useTranslation("common");

  useEffect(() => { }, []);

  return (
    <ThemeProvider theme={theme}>
      <TableToolbar className={classNames("flex items-center justify-between", className)}>
        <Box className="grid grid-cols-7 gap-4 w-full">
          <Box className="col-span-3">
            <TableToolbarSearch
              placeholder={translate("searchByNumberOrAlternative")}
              value={query?.search}
              onChange={handleSearch}
              width="100%"
            />
          </Box>

          <Box className="col-span-2">
            <TableToolbarSelect
              label={translate("category")}
              items={categories}
              value={query?.categoryId}
              onChange={handleCategoryChange}
              widthFull={true}
            />
          </Box>

          <Box className="col-span-2">
            <TableToolbarSelect
              label={tCommon("brand")}
              items={manufacturers}
              value={query?.manufacturerId}
              onChange={handleManufacturerChange}
              widthFull={true}
            />
          </Box>
        </Box>
      </TableToolbar>
    </ThemeProvider>
  );
};

export default InstalledStockItemsTableToolbar;
